import Link from 'next/link';
import { Picture } from '@workspace/ui/common';
import { SanityImage } from '@workspace/interfaces';
import { LinkTarget } from '@workspace/ui/common';

interface ContactSupportImageProps {
  image?: SanityImage;
  imageAlt?: string;
  imageHref?: string;
  imageTarget?: LinkTarget;
}

export function ContactSupportImage({
  image,
  imageAlt = 'Contact support image',
  imageHref,
  imageTarget = '_self',
}: ContactSupportImageProps) {
  if (!image?.asset?._ref && !image?.url) return null;

  const altText = image?.bynderImage?.alt || image?.alt || imageAlt;

  const imageElement = (
    <div className="relative md:h-135.5 w-full md:w-101.5 overflow-hidden">
      <Picture image={image} alt={altText} desktopWidth={406} desktopHeight={542} fill imgClassName="object-cover" />
    </div>
  );

  return (
    <div className="order-1 md:order-0 hidden md:block">
      {imageHref ? (
        <Link
          href={imageHref}
          target={imageTarget}
          rel={imageTarget === '_blank' ? 'noopener noreferrer' : undefined}
          className="block"
        >
          {imageElement}
        </Link>
      ) : (
        imageElement
      )}
    </div>
  );
}
